module.exports = __webpack_public_path__ + "img/play-to-earn-tokens.9bae964e.png";